import script from "./MarketView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketView.vue?vue&type=script&setup=true&lang=ts"

import "./MarketView.vue?vue&type=style&index=0&id=3653fd32&lang=css"

const __exports__ = script;

export default __exports__